<template>
  <mds-section border-position="bottom" bold>
    <template #mds-section-title>
      <span id="title-id">{{ filterInfo.title }}</span>
    </template>
    <template #mds-section-actions>
      <mds-button-container right-aligned>
        <mds-button
          v-for="element in filterInfo.actionButtons"
          :key="element.id"
          :variation="element.variation"
          type="button"
          @click="$emit('buttonclick', element.method)"
          >{{ element.text }}</mds-button
        >
      </mds-button-container>
    </template>

    <template>
      <adl-grid
        :headers="headers"
        :rows="rows"
        :infoText="infoText"
        :singleHeading="singleHeading"
        :singleHeadingButtonText="singleHeadingButtonText"
        :singleHeadingOptions="singleHeadingOptions"
        :gridSplitId="gridSplitId"
        :isShowHint="isShowHint"
        :focusElementName="focusElementName"
        :infoError="infoError"
        :rowTemplateButton="rowTemplateButton"
        :gridButtonTemplate="gridButtonTemplate"
        @onChange="onChange"
        @editableRowButtonClick="editableRowButtonClick"
        @OuterRowButtonClick="OuterRowButtonClick"
        :emptyGridData="emptyGridData"
      >
        <template v-slot:message> <slot name="message"></slot></template>
      </adl-grid>
    </template>
  </mds-section>
</template>

<script>
import { MdsButton, MdsButtonContainer } from "@mds/button";
import MdsSection from "@mds/section";
import AdlGrid from "./grid.vue";

export default {
  name: "AdlEditableGrid",
  components: {
    MdsButton,
    MdsButtonContainer,
    MdsSection,
    AdlGrid,
  },
  props: {
    filterInfo: {
      type: Object,
    },
    headers: {
      type: Array,
    },
    rows: {
      type: Array,
    },
    emptyGridData: {
      type: Object,
    },
    infoText: {
      type: Array,
    },
    singleHeading: {
      type: String,
    },
    singleHeadingOptions: {
      type: Array,
    },
    singleHeadingButtonText: {
      type: String,
    },
    gridSplitId: {
      type: String,
    },
    isShowHint: {
      type: Boolean,
    },
    focusElementName: {
      type: String,
    },
    editableRowStyle: {
      type: Object,
    },
    infoError: {
      type: Boolean,
    },
    gridButtonTemplate: {
      type: Array,
    },
    rowTemplateButton: {
      type: Array,
    },
  },
  async created() {},
  computed: {
    singleHeadingOptionsfilter() {
      let headingArray = Object.assign([], this.singleHeadingOptions);
      if (this.gridSplitId == "" && this.rows.length > 0) {
        return headingArray;
      }
      let filteredArray = [];
      if (this.rows.length > 0) {
        for (let i = 0; i < headingArray.length; i++) {
          if (
            this.rows.filter(
              (s) => s[this.gridSplitId].value == headingArray[i].key
            ).length > 0
          ) {
            filteredArray.push(headingArray[i]);
          }
        }
      }
      return filteredArray;
    },
  },
  data() {
    return {};
  },
  methods: {
    reset(callBackMethod) {
      this.$emit(callBackMethod);
    },
    onChange(ind) {
      this.$emit("onChange", ind);
    },
    setFocusOnGridRow() {
      this.$emit("setFocusOnRowElement");
    },
    editableRowButtonClick(callBackMethod, data, rowindex) {
      this.$emit("editableRowButtonClick", callBackMethod, data, rowindex);
    },
    OuterRowButtonClick(callBackMethod, data) {
      this.$emit("OuterRowButtonClick", callBackMethod, data);
    },
  },
};
</script>
